import { render, staticRenderFns } from "./ReviewFormConsentItemsSection.vue?vue&type=template&id=e34cddbc&scoped=true"
import script from "./ReviewFormConsentItemsSection.vue?vue&type=script&lang=js"
export * from "./ReviewFormConsentItemsSection.vue?vue&type=script&lang=js"
import style0 from "./ReviewFormConsentItemsSection.vue?vue&type=style&index=0&id=e34cddbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34cddbc",
  null
  
)

/* custom blocks */
import block0 from "./ReviewFormConsentItemsSection.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports